class ReviewCarousel extends HTMLElement {
  constructor() {
    super();

    this.sliderSelector = this.dataset.selector;
    this.reviewSlider   = this.querySelector(`#${this.sliderSelector}`);

  }

  connectedCallback() {
    const config = {
      dots: false,
      loop: true,
      arrows: false,
      autoplay: false,
      spaceBetween: 16,
      navigation: {
        nextEl: ".swiper-"+this.sliderSelector+"-next",
        prevEl: ".swiper-"+this.sliderSelector+"-previous",
      },
      arrows: true,
      breakpoints: {
        320: {
          slidesPerView: 1,
          slidesPerGroup: 1,
        },
        480: {
          slidesPerView: 2,
          slidesPerGroup: 1,
        },
        768: {
          slidesPerView: 2.5,
          slidesPerGroup: 1,
        },
        880: {
          slidesPerView: 3,
          slidesPerGroup: 1,
        },
      }
    };

    new Swiper(this.reviewSlider, config);
  }
}
customElements.define("review-carousel", ReviewCarousel);
